/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Show_WpmInputs */



/**
* | output |
* | --- |
* | "Show Words Per Minute (WPM)" |
*
* @param {Options_Metrics_Show_WpmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_show_wpm = /** @type {((inputs?: Options_Metrics_Show_WpmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Show_WpmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Show Words Per Minute (WPM)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Show Words Per Minute (WPM)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Show Words Per Minute (WPM)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Show Words Per Minute (WPM)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Show Words Per Minute (WPM)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Show Words Per Minute (WPM)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Show Words Per Minute (WPM)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Show Words Per Minute (WPM)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Show Words Per Minute (WPM)")
	return /** @type {LocalizedString} */ ("Show Words Per Minute (WPM)")
});